/* eslint-disable no-undef */
<template>
	<header id="header" class="header" v-bind:class="{ 'status-logout': !userLogged }">
		<div class="container relative">
			<div class="logo">
				<router-link to="/">
					<LOGO />
				</router-link>
			</div>
			<div class="menu_bt">
				<a href="#menu">
					<span class="menu_bt_sep"></span>
				</a>
			</div>
			<div class="mobile_only head_favorite">
				<router-link :to="{ path: globalOption.pages.favs.replace(wpData.home_url, '') }">
					<span class="favorite_num">{{ numOfFavs }}</span>
					<HEART />
				</router-link>
			</div>
			<div class="mobile_only m_icon_search">
				<a href="javascript:void(0);">
					<SEARCH />
				</a>
			</div>
			<div class="mobile_only head_search_m" >
				<div class="head_search" >
					<form method="get" @submit.prevent="goToSearch">
						<div class="head_search_input">
							<vue-simple-suggest
								ref="topSearch"
								v-model="search"
								:list="searchProducts"
								:min-length="2"
								mode="input"
								:debounce="1000"
								value-attribute="name"
								:controls="{ selectionUp: [38], selectionDown: [40] }"
								display-attribute="name"
								:filter-by-query="false"
								:prevent-submit="false"
								:destyled="true"
								@select="onSuggestSelect"
                @request-done="onShowList"
							>
								<input
									type="text"
									id="search"
									:value="search"
                  inputmode="search"
									autocomplete="off"
									placeholder="חיפוש..."
                  @keyup.enter="goToSearch"
                  ref="searchInput"
								/>
								<template slot="misc-item-above" slot-scope="{ suggestions }">
									<!-- Show "No result" otherwise, if not loading new ones -->
									<div class="no-results" style=" height:47px;" v-if="suggestions.length == 0">
										<span style="padding:5px 15px; hieght:47px;">לא נמצאו תוצאות ראשוניות...</span>
									</div>
								</template>
								<div
									slot="suggestion-item"
									:data-hover="suggestion.id"
									slot-scope="{ suggestion }"
									class="custom"
									:data-index="getSearchSuggestionIndex(suggestion)"
									:data-productid="suggestion.id"
								>
									<div class="clearfix">
										<span class="img-wrap right">
											<img class :src="suggestion.image" />
										</span>

										<span class="right autoc_tx">
											<span class="pr_title" v-html="suggestion.name"></span>
											<span class="pr_title_note"></span>
										</span>
									</div>
								</div>
								<div class="misc-item" slot="misc-item-below">
									<span class="goto_results ease">
										<router-link :to="{ path: '/', query: { s: search } }"
											>לכל התוצאות&nbsp;&nbsp;</router-link
										>
									</span>
								</div>
							</vue-simple-suggest>
						</div>
						<div class="head_search_submit">
							<input type="submit" value @click.prevent="goToSearch()" />
							<SEARCH />
						</div>
					</form>
				</div>
			</div>
			<cart-head></cart-head>
			<cart-alert />

			<CartRecoveredNotice v-if="$store.state.showCartRecoveredNotice" />

			<div class="head_width">
				<div class="head_top clearfix">
					<div class="right head_search" :class="this.$route.query.s ? 'search-page' : ''">
						<form method="get" ref="searchForm" @submit.prevent="goToSearch(true)" v-if="$mq !== 'mobile'">
							<div class="head_search_input">
								<vue-simple-suggest
									ref="topSearch"
									@hover="onHover"
									v-model="search"
									:list="searchProducts"
									:min-length="2"
									mode="input"
									:debounce="1000"
									value-attribute="name"
									:controls="{ selectionUp: [38], selectionDown: [40], hideList: [13] }"
									display-attribute="name"
									:filter-by-query="false"
									:destyled="true"
									@select="onSuggestSelect"
                  @request-done="onShowList"
								>
									<input
										type="text"
										id="search"
                    inputmode="search"
										:value="search"
										autocomplete="off"
										placeholder="חיפוש..."
                    @keyup.enter="goToSearch"
                    ref="searchInput"
									/>
									<template slot="misc-item-above" slot-scope="{ suggestions }">
										<!-- Show "No result" otherwise, if not loading new ones -->
										<div class="no-results" style=" height:47px;" v-if="suggestions.length == 0">
											<span style="padding:5px 15px; hieght:47px;"
												>לא נמצאו תוצאות ראשוניות...</span
											>
										</div>
									</template>

									<div
										slot="suggestion-item"
										slot-scope="{ suggestion }"
										class="custom"
										:data-index="getSearchSuggestionIndex(suggestion)"
										:data-productid="suggestion.id"
									>
										<div class="clearfix">
											<span class="img-wrap right">
												<img class :src="suggestion.image" />
											</span>
											<span class="right autoc_tx">
												<span class="pr_title" v-html="suggestion.name"></span>
												<span class="pr_title_note"></span>
											</span>
										</div>
									</div>

									<template class="custom" slot="misc-item-below">
										<span class="goto_results ease">
											<a href="#" @click.prevent="goToSearch()">לכל התוצאות</a>
										</span>
									</template>
								</vue-simple-suggest>
							</div>
							<div class="head_search_submit">
								<input type="submit" value @click.prevent="goToSearch()" />
								<SEARCH />
							</div>
						</form>
					</div>
					<div class="right head_nav">
						<div class="clearfix">
							<div class="right head_nav_link" v-for="(item, index) in topMenu" :key="index">
								<a-div :href="parseLink(item.top.url)">{{ item.top.title }}</a-div>
							</div>

							<div class="right head_soc clearfix">
								<div class="right head_soc_item">
									<a :href="globalOption.instagram_link" target="_blank">
										<SC_INST />
									</a>
								</div>
								<div class="right head_soc_item">
									<a :href="globalOption.facebook_link" target="_blank">
										<SC_FACE />
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="left head_links clearfix">
						<div class="m_icon_search icon_search_desk">
							<a href="javascript:void(0);">
								<SEARCH />
							</a>
						</div>

						<div class="right head_link hasTooltip gift-card-icon">
							<router-link :to="{ name: 'giftCardPurchase' }">
								<span class="text">גיפט קארד</span>
								<GIFTCARDICON />
							</router-link>
						</div>

						<div
							class="right head_link hasTooltip"
							title="לקיצור התהליך אפשר לשחזר ולערוך הזמנות קודמות"
							@click="$root.$emit('go_to_history', 1)"
						>
							<router-link :to="{ name: 'history' }">
								{{ !this.$store.state.hasOrderEdit ? "שחזור הזמנה" : "עריכת הזמנה" }}
								<REFRESH />
							</router-link>
						</div>
						<div class="right head_link head_favorite">
							<router-link
								:to="{
									path: globalOption.pages.favs.replace(wpData.home_url, ''),
									params: { state: 'favorites' }
								}"
							>
								מועדפים
								<span class="favorite_num">{{ numOfFavs }}</span>
								<HEART />
							</router-link>
						</div>
						<div class="right head_register_link" v-if="!userLogged" style="display:none;">
							<a href="javascript:void(0);" @click.prevent="showLoginModal('reg')">הצטרפות לכרמלה</a>
						</div>
						<div class="right head_link link_logout" v-if="!userLogged">
							<a href="javascript:void(0);" @click.prevent="showLoginModal('login')">
								כניסה
								<USER />
							</a>
						</div>
						<div class="right login header_account toggleContainer" v-if="userLogged">
							<div class="login_top">
								<a class="name-of-user" href="javascript:void(0);" onclick="toggleAccountMenu(this);">
									היי, {{ user.firstname }}
									<span class="user-svg">
										<USER />
									</span>
									<span class="user-arrow">
										<ARROWDOWN />
									</span>
								</a>
							</div>
							<div class="login_open toggleInner">
								<div class="login_open_top">
									<HOME />
									<div class="open_add">
										<span style="display:none;">הכתובת שלי:</span>
										{{ user.street }} {{ user.house }}, {{ user.city }}
									</div>
									<div class="open_add_link">
										<router-link :to="{ name: 'myaccount' }">החלפת כתובת</router-link>
									</div>
								</div>
								<div class="login_open_in">
                  <div class="cashback" v-if="cashback.options.enabled">
                    <router-link :to="{name: 'cashback'}" class="cashback-title" onclick="toggleAccountMenu(this);">
                      <Cashback/>
                      כרמלה קאשבק
                    </router-link>
                    <div class="cashback-message">
                      <div v-if="cashback.points">
                        צברת {{ cashback.points }} נק', ששוות {{ getCashbackPointsWorth }} ₪
                      </div>
                      <div v-else class="no-points">
                        אין פה נקודות, זו ההזדמנות להתחיל לצבור!
                      </div>
                    </div>
                  </div>
									<div class="login_open_link">
										<router-link :to="{ name: 'myaccount' }">
											החשבון שלי
											<USER_STROKE />
										</router-link>
									</div>
									<div class="login_open_link">
										<router-link
											:to="{
												path: '/my-account/history',
												params: { state: 'history' }
											}"
										>
											היסטוריית הזמנות
											<TIME />
										</router-link>
									</div>
									<div class="login_open_link">
										<router-link
											:to="{
												path: globalOption.pages.favs.replace(wpData.home_url, '')
											}"
										>
											המועדפים שלי
											<HEART />
										</router-link>
									</div>
									<div class="login_open_link">
										<router-link
											:to="{
												path: '/my-account/permenant',
												params: { state: 'order' }
											}"
										>
											<b>
												כרמלה בקבוע
											</b>
											<span class="soon-sm" v-if="false">(בקרוב)</span>
											<ADDBOOK />
										</router-link>
									</div>
									<div class="login_open_link">
										<a href="javascript:void(0);" @click="userLogout">
											{{getLogoutText}}
											<LOGOUT />
										</a>
									</div>

									<div id="admin-tools-link" v-if="user && user.isAdmin">
										<router-link :to="{ name: 'adminTools' }">
											<b>כלים למנהלי האתר</b>
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right desk_menu ease">
						<a href="#menu">
							תפריט מוצרים
							<span class="ds_sep">
								<span class="ds_sep_in"></span>
							</span>
						</a>
					</div>
				</div>
				<Menu v-bind:menu="menu" v-bind:assets="wpData.assets_url" v-if="this.$mq != 'mobile'" />
				<mobile-menu v-bind:menu="menu" />
			</div>
		</div>

		<div class="back_top ease">
			<a href="javascript:void(0);" onclick="backToTop();">
				<span class="go_arrow ease">
					<BACKTOP />
				</span>
			</a>
		</div>
	</header>
</template>
<script>
	import Menu from "./Menu";
	import MobileMenu from "./MobileMenu";
	import CartHead from "../Cart/CartHead";
	import CartAlert from "../Cart/CartAlert";
	import CartRecoveredNotice from "../Cart/CartRecoveredNotice";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import { mapActions, mapGetters } from "vuex";
	import SaveCartPreset from "./SaveCartPreset.vue";

	/** import SVG */
	import LOGO from "../../assets/img/logo.svg";
	import SEARCH from "../../assets/img/search.svg";
	import HEART from "../../assets/img/heart.svg";
	import ADDBOOK from "../../assets/img/addbook.svg";
	import ARROWDOWN from "../../assets/img/arrow_down.svg";
	import SC_INST from "../../assets/img/sc_inst.svg";
	import SC_FACE from "../../assets/img/sc_face.svg";
	import REFRESH from "../../assets/img/refresh.svg";
	import USER_STROKE from "../../assets/img/user-stroke.svg";
	import TIME from "../../assets/img/time.svg";
	import USER from "../../assets/img/user.svg";
	import HOME from "../../assets/img/home.svg";
	import LOGOUT from "../../assets/img/logout.svg";
	import BACKTOP from "../../assets/img/back-top.svg";
	import GIFTCARDICON from "../../assets/img/giftcard_icon.svg";
	import "vue-simple-suggest/dist/styles.css"; // Using a css-loader
  import Cashback from "../../assets/img/cashback.svg";
  import store from "@/store";

	export default {
		// props: ["pages"],
		data() {
			return {
				wpData: wpData,
				search: '',
				loadingResults: false,
				globalOption: wpData.globalOptions,
				menu: JSON.parse(wpData.header_menu),
				controls: {
					selectionUp: [38],
					selectionDown: [40]
				},
				sentSearchQueries: [],
        cashback: this.$store.state.cashback
			};
		},
		mounted() {
			this.$root.$on("closeProductPop", () => {
				this.search = "";
			});
      this.$nextTick(() => {
        const _this = this;
        $(document.body).on('mousedown', '.goto_results a', function(){
          _this.goToSearch();
        });
      });
		},
		updated() {},
		watch: {
			$route(to, from) {
				if (to.query.s || from.query.s) {
					//this.search = "";
				}
				if ($(".m_icon_search").hasClass("active")) {
					$(".m_icon_search").trigger("click");
					$(".head_search_m").slideUp();
				}
			},
      // search(to, from) {
      //   console.log('search', to);
      //   this.$store.commit("setSearch", to);
      // }
		},
 		methods: {
			...mapActions([
				"userLogout",
				"openPopupProduct",
				"getLastOrder",
				"updateCartFromServer",
				"sendCartToServer"
			]),
			getSearchSuggestionIndex(item) {
				const items = this.$refs.topSearch.suggestions;
				return items.findIndex(o => o.id == item.id);
			},
			showLoginModal(state) {
				this.$modal.show("login-modal", {
					state: state
				});
			},
			// onSearchEnter() {
      //   if (!this.$route.query.length) {
      //     const _this = this;
      //     setTimeout(function(){
      //       _this.search = "";
      //     }, 100);
      //     this.goToSearch();
      //   }
			// },
      onShowList() {
        if (this.$route.query.s && this.$route.query.s !== '' && this.search && this.$mq !== 'mobile') {
          //this.$router.push({ path: "/", query: { s: this.search } });
        }
      },
			onHover(suggestion, element) {
				// If the hover is via mouse, an element will be present. We are only interested in hovers with keyboard
				// so that we can scroll properly.

				if (typeof element == "undefined") {
					// Wait for next tick so that the DOM is updated and the hover class is on the latest element instead
					// of the previous one.

					this.$nextTick(() => {
						const overlayElement = document.getElementsByClassName("suggestions")[0];
						const hoveredElement = overlayElement.getElementsByClassName("suggest-item hover")[0];
						// const hoveredElement = document.querySelector(
						//   ".suggestion-item.hover"
						// );

						this.scrollToElement(hoveredElement, overlayElement);
					});
				}

				this.$emit("hover", suggestion, element);
			},
			scrollToElement(element, parentElement) {
				if (parentElement && parentElement.contains(element)) {
					const { clientHeight, scrollTop } = parentElement;
					const { offsetHeight, offsetTop } = element;

					if (offsetTop < scrollTop) {
						parentElement.scrollTop = offsetTop; // scroll up
					} else {
						const offsetBottom = offsetTop + offsetHeight;
						const scrollBottom = scrollTop + clientHeight;
						if (offsetBottom > scrollBottom) {
							parentElement.scrollTop = offsetBottom - clientHeight; // scroll down
						}
					}
				}
			},
			// getPage(id) {
			//   return this.pages.find(p => p.id === id);
			// },
			// getPageLink(id) {
			//   var page = this.pages.find(p => p.id === id);
			//   if (page) {
			//     return decodeURI(page.slug);
			//   }
			// },
			onSuggestSelect(product) {
        const _this = this;
				setTimeout(function(){
          _this.search = "";
        }, 100);
				this.openPopupProduct([product]).then(() => {
					this.$modal.show("prod-modal");
				});

				// Google analytics tag
				const queryString = document.querySelector("#search").value;
				const clickedDomItem = document.querySelector(
					'.head_search ul .suggest-item .custom[data-productid="' + product.id + '"]'
				);
				const clickedDomIndex = parseInt(clickedDomItem.getAttribute("data-index")) + 1;
				this.sentSearchQueries.push(product.name);
				if (typeof ga !== "undefined") {
					ga.getAll()[0].send({
						hitType: "event",
						eventCategory: "Product search",
						eventAction: "Result click",
						eventLabel:
							"Query: " +
							decodeURIComponent(queryString) +
							", Product ID: " +
							product.id +
							", Order: " +
							clickedDomIndex,
						eventValue: 0,
						nonInteraction: false
					});
					// Google Analytics v4, GA4, GTM, Google tag manager
					// Result click
					const dataLayer = window.dataLayer || [];
					dataLayer.push({
						event: "search_result_clicked",
						search_term: decodeURIComponent(queryString),
						product_id: product.id,
						list_index: clickedDomIndex
					});
				}
			},
			goToSearch(inSubmit = false) {
        console.log('gotosearch', this.search, this.$refs.searchInput.value);
        this.search = this.$refs.searchInput.value;
        this.$store.commit("setSearch", this.search);
        //if (this.search != '') {
          console.log('gotosearch2');
          //let term = this.search;
          let term = this.$refs.searchInput.value;
          this.$refs.topSearch.hideList();
          this.$router.push({ path: "/", query: { s: term } });
        //}
			},
			parseLink(link) {
				return link.replace(wpData.home_url, "");
			},
			searchProducts(s) {
        if (this.loadingResults) {
          return false;
        }
				return new Promise((resolve, reject) => {
          this.loadingResults = true;
					this.$ajax({
						method: "POST",
						url: homeUrl + "ajax.php",
						params: {
							search: s
						}
					}).then(res => {
						let foundProducts = res.data;
						if (typeof foundProducts != "undefined" && foundProducts.length > 0) {
							if (s == "ביצי" || s == "ביצים") {
								foundProducts.sort(function(a, b) {
									if (a.categories.includes(28)) {
										return -1;
									}
									if (b.categories.includes(28)) {
										return 1;
									}
									return 0;
								});
							} else {
								foundProducts.sort(function(a, b) {
									if (
										a.categories.includes(16) ||
										a.categories.includes(105) ||
										a.categories.includes(22)
									) {
										return -1;
									}
									if (
										b.categories.includes(16) ||
										b.categories.includes(105) ||
										b.categories.includes(22)
									) {
										return 1;
									}
									return 0;
								});
							}
						}
						this.loadingResults = false;

						// Google analytics tag
						if (!this.sentSearchQueries.includes(s) && typeof s !== "undefined") {
							this.sentSearchQueries.push(s);
							if (typeof ga !== "undefined") {
								ga.getAll()[0].send({
									hitType: "event",
									eventCategory: "Product search",
									eventAction: "Search query",
									eventLabel: decodeURI("Query: " + s + ", Results: " + foundProducts.length),
									eventValue: 0,
									nonInteraction: false
								});
							}
							// Google Analytics v4, GA4, GTM, Google tag manager
							// Result click
							const dataLayer = window.dataLayer || [];
							dataLayer.push({
								event: "search",
								search_term: decodeURI(s),
								result_count: foundProducts.length
							});
						}

            this.$store.commit("setSearchResultProducts", res.data);
            if (!this.$route.query.s) {
              //this.$store.commit("setSearchResultProducts", res.data);
            } else {
              //this.$store.commit("setSearchResultProducts", []);
            }
            this.$store.commit("setSearch", s);
						resolve(foundProducts);
					});
				});
			}
		},
		computed: {
      ...mapGetters(["getCashbackPointsWorth", "getLogoutText"]),
			numOfFavs() {
				return this.$store.state.storedFavs.length;
			},
			userLogged() {
				return this.$store.state.userLogged;
			},
			w_width() {
				return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			},
			user() {
				return this.$store.state.userLoggedInfo;
			},
			products() {
				let p = this.$store.state.products;
				p.sort(function(a, b) {
					if (a.categories.includes(16) || a.categories.includes(105) || a.categories.includes(22)) {
						return -1;
					}
					if (b.categories.includes(16) || b.categories.includes(105) || b.categories.includes(22)) {
						return 1;
					}
					return 0;
				});
				return p;
			},
			topMenu() {
				return JSON.parse(wpData.top_menu);
			}
		},
		components: {
			Menu,
			LOGO,
			CartAlert,
			CartHead,
			CartRecoveredNotice,
			SEARCH,
			HEART,
			ADDBOOK,
			ARROWDOWN,
			HOME,
			USER_STROKE,
			USER,
			REFRESH,
			SC_FACE,
			SC_INST,
			TIME,
			LOGOUT,
			BACKTOP,
			MobileMenu,
			VueSimpleSuggest,
			GIFTCARDICON,
			SaveCartPreset,
      Cashback
		}
	};
</script>
<style>
	.suggestions {
		background-color: #fff;
		border-radius: 5px;
		position: relative;
		z-index: 300;
	}
	.suggestions img {
		max-width: 45px;
	}
	.no-results {
		height: 47px;
		display: flex;
		align-items: center;
	}
	.suggestions .custom {
		cursor: pointer;
		min-height: 37px;
	}

	.head_top .head_links .gift-card-icon {
		position: relative;
	}
	.head_top .head_links .gift-card-icon .new {
		position: absolute;
		top: -12px;
		right: 32px;
		font-weight: bold;
		font-size: 0.75rem;
		color: red;
	}
	.head_top .head_links .gift-card-icon .text {
		display: inline-block;
		font-size: 14px;
		margin-right: 6px;
	}
	.head_top .head_links .gift-card-icon svg {
		transform: scale(0.9);
	}

	.name-of-user {
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 7.4rem;
		padding: 0 18px 18px 11px !important;
		white-space: nowrap;
	}

	.head_link a {
		margin-left: 10px;
	}

	/* Thin desktop */
	@media screen and (min-width: 1350px) and (max-width: 1455px) {
		.head_top .head_links .gift-card-icon a {
			padding-right: 4px;
		}
		.head_top .head_links .gift-card-icon .new {
			right: 10px;
		}
		.head_top .head_links .gift-card-icon svg {
			display: none;
		}
	}

	#admin-tools-link {
		margin: 1rem 0 0.5rem 0;
	}

	#admin-tools-link b {
		color: red;
	}
  /*.search-page .vue-simple-suggest > ul {
    display: none;
  }*/
</style>
<style lang="sass" scoped>
.cashback
  margin: 0 -15px 15px
  padding: 0 20px 10px
  border-bottom: 1px dashed #1e824c
  .cashback-title
    color: #1e824c
    font-weight: 900
    display: flex
    vertical-align: middle
    column-gap: 5px
    padding-right: 40px
    svg
      position: absolute
      right: 12px
  .cashback-message
    padding-right: 40px
    color: #000
    .no-points
      color: #EA4725
      font-size: 12px

</style>